import React from 'react'
import PropTypes from 'prop-types'
import HomeImage from '../../assets/img/account.svg'

import { MouseIndicator } from '../fragments/mouse'

function Inicio({title, subtitle}){
    return(
        <section id="up" className="home">
            <div data-aos="zoom-in">
                <img src={HomeImage} alt="" width="300px" />
                <h1 className="title">{title}</h1>
                <p className="subtitle">{subtitle}</p>
                <button className="btn btn-primary"><a href="#contact">Contactame</a></button>
            </div>

            <MouseIndicator />
        </section>
    )
}

Inicio.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string
}

Inicio.defaultProps = {
    title: 'No se encontró titulo',
    subtitle: 'No se encontró contenido'
}

export default Inicio